import {SpectrumEventType} from '@/enums/diagrams';
import {formatUnit} from '@/utils/unitUtils';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {SignalDiagramData, SpectrumDiagramData} from './interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {
  PModuleStoreModule,
  PModuleSpectrumStoreModule,
} from '@/store/modules/entities/pmodules/interfaces';
import {PModuleType} from '@/enums/configs';
import {DtcpAccelerometerStoreModule} from '@/store/modules/entities/pmodules/dtcp/dtcpAccelerometerStoreModule';

// Получить наименование оси Y диаграммы
export function getYAxisName(diagram: SignalDiagramData | SpectrumDiagramData) {
  const unit = formatUnit(diagram.measurement.unit);
  return `${diagram.measurement.yAxisDescription}${unit != '-' ? ', ' + unit : ''}`;
}

// Получить заголовок диаграммы сигнала
export function getSignalDiagramTitle(measurement: MeasurementData) {
  const unit = formatUnit(measurement.unit);
  return `${measurement.name}${unit != '-' ? ', ' + unit : ''}`;
}

// Получить заголовок диаграммы спектра
export function getSpectrumDiagramTitle(measurement: MeasurementData) {
  return measurement.name;
}

// TODO: потом убрать - сейчас для поддержки нереляционного кода
export function getSpectrumEventTypeNumber(eventType: string) {
  if (eventType === 'energe_spectrum_changed') return SpectrumEventType.Energy;
  if (eventType === 'envelope_spectrum_changed') return SpectrumEventType.Envelop;
  if (eventType === 'low_spectrum_changed') return SpectrumEventType.Low;
  return SpectrumEventType.Low;
}

// TODO: потом убрать - сейчас для поддержки нереляционного кода
export function getSpectrumEventTypeNumberStr(eventType: SpectrumEventType) {
  if (eventType === SpectrumEventType.Energy) return 'energe_spectrum_changed';
  if (eventType === SpectrumEventType.Envelop) return 'envelope_spectrum_changed';
  if (eventType === SpectrumEventType.Low) return 'low_spectrum_changed';
  return '';
}

export function getAccelerometerApiStore(moduleType: PModuleType): DtcpAccelerometerStoreModule {
  return pmoduleStoresByTypeMap.get(moduleType) as DtcpAccelerometerStoreModule;
}

export function getApiStore(moduleType: PModuleType): PModuleStoreModule {
  return (pmoduleStoresByTypeMap.get(moduleType) as any) as PModuleStoreModule;
}

export function getApiStoreSpectrum(moduleType: PModuleType): PModuleSpectrumStoreModule {
  return (pmoduleStoresByTypeMap.get(moduleType) as any) as PModuleSpectrumStoreModule;
}
